import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-facebookpolicy',
  templateUrl: './facebookpolicy.component.html',
  styleUrls: ['./facebookpolicy.component.css']
})
export class FacebookpolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
